import styles from "./styles.module.scss";
import Footer from "../../components/Footer"
import Header from "../../components/ServicesPage/MobileDevPage/Header"
import React, { useRef } from 'react'
import Services from "../../components/ServicesPage/MobileDevPage/Services";



function Home() {
  const intro = useRef(null)
  const services = useRef(null)
  const processus = useRef(null)
  const value = useRef(null)
  const contact = useRef(null)

  return (
    <>
      <section className={styles.Container}>
        <div className={styles.navBar}>
          <Header intro={intro} services={services} processus={processus} value={value} contact={contact}/>
        </div>      
        <div className={styles.services} ref={services}>
          <Services />
        </div>
        <div className={styles.footer}>
          <Footer />
        </div>
        
      </section>
    </>
  );
}

export default Home;